module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.html.js
 ** module id = 99
 ** module chunks = 0
 **/